// ========================================
// Mis notas (alumno) — diseño A, oct. 2026: el periodo elegido con la nota
// grande y las observaciones, cada aspecto y la evolución entre periodos.
// ========================================
const CalificacionesStudentView = {
    _calificaciones: [],
    _request: 0,
    _group: null, // formationId|year
    _period: null,
    PERIODS: [['1Trimestre', '1.er trimestre'], ['2Trimestre', '2.º trimestre'], ['Final', 'Final']],
    CRITERIA: [['tecnica', 'Técnica'], ['lenguaje', 'Lenguaje y estética'], ['compromiso', 'Compromiso'], ['colectivo', 'Colectivo'], ['adaptabilidad', 'Adaptabilidad']],
    destroy() { ++this._request; this._calificaciones = []; },
    render() {
        return `
        <div class="view-container dnr-proposal mnt-view" style="padding-top: 1rem;">
            <style ${SafeHTML.styleAttr}>
                .mnt-view { gap: 0.85rem; }
                .mnt-view [hidden] { display: none !important; }
                .mnt-retry { margin-top: 1rem; min-height: 36px; padding: 0 14px; border: 1px solid var(--dnr-line); border-radius: 10px; background: var(--dnr-surface); color: var(--dnr-ink); font-weight: 700; cursor: pointer; font-family: inherit; }
                .mnt-top { display: flex; flex-wrap: wrap; align-items: center; gap: 0.6rem; }
                .mnt-title { margin: 0; flex: 1; font-family: var(--dnr-display); font-weight: 400; font-size: 2.4rem; letter-spacing: 0.02em; line-height: 1; color: var(--dnr-ink); }
                .mnt-seg { display: inline-flex; gap: 3px; padding: 3px; background: var(--dnr-surface-sunken); border: 1px solid var(--dnr-line); border-radius: 11px; flex-wrap: wrap; }
                .mnt-seg button { min-height: 34px; padding: 0 14px; border: 0; border-radius: 8px; background: transparent; color: var(--dnr-ink-mute); font-weight: 700; font-size: 0.85rem; cursor: pointer; font-family: inherit; }
                .mnt-seg button.is-on { background: var(--dnr-surface); color: var(--dnr-teal-900); box-shadow: 0 1px 3px rgba(0,0,0,.12); }
                .mnt-seg button:disabled { opacity: 0.45; cursor: default; }
                .mnt-label { font: 700 0.68rem var(--dnr-mono); letter-spacing: 0.08em; text-transform: uppercase; color: var(--dnr-ink-mute); }
                .mnt-layout { display: grid; grid-template-columns: 340px minmax(0, 1fr); gap: 0.85rem; align-items: start; }
                .mnt-hero { background: var(--dnr-ink); color: #fff; border-radius: 16px; padding: 1.25rem 1.35rem; display: flex; flex-direction: column; gap: 0.5rem; }
                .mnt-hero .mnt-label { color: #A9C9C2; }
                .mnt-grade { font-family: var(--dnr-display); font-size: 4.5rem; line-height: 0.9; letter-spacing: 0.02em; }
                .mnt-grade.is-apto { color: #7FD3C3; }
                .mnt-grade.is-aviso { color: #F0B871; }
                .mnt-grade.is-no { color: #F0A097; }
                .mnt-grade.is-none { color: #A9B6B1; }
                .mnt-hero small { font-size: 0.88rem; color: #DDE7E4; }
                .mnt-obs { margin-top: 0.6rem; padding-top: 0.75rem; border-top: 1px solid rgba(255,255,255,.15); }
                .mnt-obs p { margin: 0.35rem 0 0; font-size: 0.95rem; line-height: 1.5; color: #fff; white-space: pre-line; }
                .mnt-card { background: var(--dnr-surface); border: 1px solid var(--dnr-line); border-radius: 16px; box-shadow: var(--dnr-shadow-card); overflow: hidden; }
                .mnt-card-head { padding: 0.75rem 1rem; border-bottom: 1px solid var(--dnr-line); }
                .mnt-rows { padding: 0.25rem 1rem 0.5rem; }
                .mnt-row { display: flex; align-items: center; gap: 12px; padding: 0.7rem 0; border-bottom: 1px solid var(--dnr-line); }
                .mnt-row b { flex: 1; font-size: 1rem; color: var(--dnr-ink); }
                .mnt-pill { min-width: 92px; text-align: center; font-weight: 700; font-size: 0.85rem; padding: 6px 12px; border-radius: 999px; }
                .mnt-evo { padding: 0.25rem 1rem 1rem; }
                .mnt-evo-grid { display: grid; grid-template-columns: 170px repeat(3, minmax(0, 1fr)); gap: 4px; margin-top: 0.5rem; font-size: 0.82rem; align-items: center; }
                .mnt-evo-grid > b { text-align: center; color: var(--dnr-ink); }
                .mnt-evo-grid > span:not(.mnt-cell) { font-weight: 700; color: var(--dnr-ink); }
                .mnt-cell { text-align: center; padding: 6px 4px; border-radius: 8px; font-weight: 700; }
                .mnt-cell.is-current { outline: 2px solid var(--dnr-ink); }
                .mnt-empty { text-align: center; padding: 3.5rem 2rem; background: var(--dnr-surface); border: 1px dashed var(--dnr-line-strong); border-radius: 16px; color: var(--dnr-ink-mute); }
                .mnt-empty h3 { font-family: var(--dnr-display); font-weight: 400; font-size: 1.5rem; letter-spacing: 0.02em; color: var(--dnr-ink); margin: 0 0 0.4rem; }
                .mnt-empty p { margin: 0; }
                @media (max-width: 900px) {
                    .mnt-layout { grid-template-columns: minmax(0, 1fr); }
                    .mnt-evo-grid { grid-template-columns: 110px repeat(3, minmax(0, 1fr)); }
                }
            </style>
            <header class="mnt-top">
                <h1 class="mnt-title">Mis notas</h1>
                <div class="mnt-seg" id="mnt-groups" role="tablist" aria-label="Formación y curso" hidden></div>
                <div class="mnt-seg" id="mnt-periods" role="tablist" aria-label="Periodo" hidden></div>
            </header>
            <div id="student-calif-list">
                <p class="mnt-empty">Cargando tus notas…</p>
            </div>
        </div>`;
    },
    async init() {
        await this.loadData();
    },
    async loadData() {
        const container = document.getElementById('student-calif-list');
        if (!container) return;
        const request = ++this._request, epoch = AuthManager._epoch;
        const current = () => request === this._request && epoch === AuthManager._epoch && container === document.getElementById('student-calif-list');
        this._calificaciones = [];
        try {
            const token = AuthManager.getCsrfToken();
            const res = await fetch('/api/calificaciones', { headers: { 'X-SICAF-CSRF': token } });
            const data = await res.json();
            if (!current()) return;
            if (!res.ok || !data.success || !Array.isArray(data.calificaciones)) throw new Error(data.error || 'No se pudieron cargar las calificaciones.');
            if (data.calificaciones.some(c => !c.nota || c.nota.studentId !== AuthManager.getStudentId())) throw new Error('No se pudo verificar el expediente.');
            this._calificaciones = data.calificaciones || [];
            this._group = null;
            this._period = null;
            this.renderList();
        } catch(e) {
            if (current()) SafeHTML.set(container, `<div role="alert" class="mnt-empty"><p>No se pudo cargar el expediente. Reintenta la carga o avisa a coordinación si sigue fallando.</p><button type="button" class="mnt-retry" ${UIEvents.attr("click", function(event,captured){CalificacionesStudentView.loadData();}, [])}>Reintentar</button></div>`);
        }
    },
    _groups() {
        const map = new Map();
        this._calificaciones.forEach(c => {
            const key = `${c.formationId}|${c.year}`;
            if (!map.has(key)) map.set(key, { key, formationName: c.formationName || 'Formación', year: c.year || '', actas: {} });
            map.get(key).actas[c.period] = c;
        });
        // El curso más reciente primero.
        return [...map.values()].sort((a, b) => String(b.year).localeCompare(String(a.year)) || a.formationName.localeCompare(b.formationName, 'es'));
    },
    selectGroup(key) { this._group = key; this._period = null; this.renderList(); },
    selectPeriod(period) { this._period = period; this.renderList(); },
    renderList() {
        const container = document.getElementById('student-calif-list');
        if (!container) return;
        const groupsEl = document.getElementById('mnt-groups'), periodsEl = document.getElementById('mnt-periods');
        const groups = this._groups();
        if (groups.length === 0) {
            if (groupsEl) groupsEl.hidden = true;
            if (periodsEl) periodsEl.hidden = true;
            SafeHTML.set(container, `<div class="mnt-empty"><h3>Sin calificaciones publicadas</h3><p>Todavía no se han publicado notas de tu curso.</p></div>`);
            return;
        }
        const group = groups.find(g => g.key === this._group) || groups[0];
        this._group = group.key;
        const published = this.PERIODS.filter(([id]) => group.actas[id]).map(([id]) => id);
        if (!published.includes(this._period)) this._period = published[published.length - 1];
        const esc = s => Utils.sanitizeHTML(String(s == null ? '' : s));

        if (groupsEl) {
            groupsEl.hidden = groups.length < 2;
            SafeHTML.set(groupsEl, groups.map(g => `<button type="button" role="tab" class="${g.key === group.key ? 'is-on' : ''}" aria-selected="${g.key === group.key}"
                ${UIEvents.attr("click", function(event,captured){CalificacionesStudentView.selectGroup(String(captured[0]));}, [g.key])}>${esc(g.formationName)} · ${esc(g.year)}</button>`).join(''));
        }
        if (periodsEl) {
            periodsEl.hidden = false;
            SafeHTML.set(periodsEl, this.PERIODS.map(([id, label]) => `<button type="button" role="tab" class="${id === this._period ? 'is-on' : ''}" aria-selected="${id === this._period}" ${group.actas[id] ? '' : 'disabled title="Aún sin publicar"'}
                ${UIEvents.attr("click", function(event,captured){CalificacionesStudentView.selectPeriod(String(captured[0]));}, [id])}>${label}</button>`).join(''));
        }

        const acta = group.actas[this._period];
        const nota = acta.nota || {};
        const periodLabel = (this.PERIODS.find(([id]) => id === this._period) || ['', ''])[1];
        const gradeClass = { APTO: 'is-apto', AVISO: 'is-aviso', 'NO APTO': 'is-no' }[nota.calificacion] || 'is-none';
        const when = acta.publishedAt ? new Date(acta.publishedAt) : null;
        SafeHTML.set(container, `
            <div class="mnt-layout">
                <section class="mnt-hero">
                    <span class="mnt-label">${esc(group.formationName)} · ${esc(periodLabel)}</span>
                    <div class="mnt-grade ${gradeClass}">${esc(this._label(nota.calificacion))}</div>
                    ${when && !isNaN(when) ? `<small>Publicada el ${esc(when.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }))}</small>` : ''}
                    <div class="mnt-obs">
                        <span class="mnt-label">Observaciones</span>
                        <p>${esc(nota.tutorias || 'Sin observaciones del equipo docente.')}</p>
                    </div>
                </section>
                <section class="mnt-card">
                    <div class="mnt-card-head"><span class="mnt-label">Cómo vas en cada aspecto</span></div>
                    <div class="mnt-rows">
                        ${this.CRITERIA.map(([field, label]) => `<div class="mnt-row"><b>${label}</b><span class="mnt-pill" style="${this._pillStyle(nota[field])}">${esc(this._label(nota[field]))}</span></div>`).join('')}
                    </div>
                    <div class="mnt-evo">
                        <span class="mnt-label">Tu evolución</span>
                        <div class="mnt-evo-grid">
                            <span></span>${this.PERIODS.map(([, label]) => `<b>${label}</b>`).join('')}
                            ${[...this.CRITERIA, ['calificacion', 'Calificación']].map(([field, label]) => `<span>${label}</span>${this.PERIODS.map(([id]) => {
                                const value = group.actas[id]?.nota?.[field];
                                return `<span class="mnt-cell ${id === this._period ? 'is-current' : ''}" style="${this._pillStyle(value)}">${esc(this._label(value))}</span>`;
                            }).join('')}`).join('')}
                        </div>
                    </div>
                </section>
            </div>`);
    },
    _label(score) {
        return { APTO: 'Apto', AVISO: 'Aviso', 'NO APTO': 'No apto' }[score] || '—';
    },
    _pillStyle(score) {
        return `background: ${this.getBgColorForScore(score)}; color: ${this.getTextColorForScore(score)};`;
    },
    getBgColorForScore(score) {
        if (score === 'APTO') return '#DCEFEA';
        if (score === 'AVISO') return '#FBEEDC';
        if (score === 'NO APTO') return '#FBE4E1';
        return '#F3F6F4';
    },
    getTextColorForScore(score) {
        if (score === 'APTO') return '#0B5A52';
        if (score === 'AVISO') return '#7A4210';
        if (score === 'NO APTO') return '#8E2A21';
        return '#55665F';
    }
};

window.CalificacionesStudentView = CalificacionesStudentView;
